'use client';

import { LazyMotion, domAnimation } from "motion/react";

import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Portfolio from '@/components/Portfolio';
import Process from '@/components/Process';
import dynamic from 'next/dynamic';

const About = dynamic(() => import('@/components/About'), { ssr: true });
const CTA = dynamic(() => import('@/components/CTA'), { ssr: true });
const Footer = dynamic(() => import('@/components/Footer'), { ssr: true });
import { LanguageProvider } from '@/context/LanguageContext';

export default function Home() {
  return (
    <LanguageProvider>
      <LazyMotion features={domAnimation}>
        <main className="min-h-screen bg-black text-white selection:bg-[#19ffb5] selection:text-black">
          <Navbar />
          <Hero />
          <Services />
          <Portfolio />
          <Process />
          <About />
          <CTA />
          <Footer />
        </main>
      </LazyMotion>
    </LanguageProvider>
  );
}
